module.exports = __webpack_public_path__ + "img/tiktok.b89ac1c6.svg";